module.exports = __webpack_public_path__ + "images/xpms全景_01.jpg?v=cc578d42";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue2/xpms全景_01.jpg
 ** module id = 124
 ** module chunks = 1 2
 **/